function sampleValueForType(type) {
  switch (String(type).toLowerCase()) {
    case "int":
    case "integer":
      return 0;

    case "float":
    case "double":
    case "number":
      return 0.0;

    case "boolean":
      return false;

    case "string":
      return "example";

    default:
      return null;
  }
}

export function generateTelemetryCurl({
  apiBase,
  deviceId,
  token,
  schema = [],
  metrics = [],
}) {
  const data = {};
  const source = [];
  const seen = new Set();

  [...(Array.isArray(schema) ? schema : []), ...(Array.isArray(metrics) ? metrics : [])].forEach((field) => {
    const key = field?.key || field?.metric_key || field?.normalized_key;
    if (!key || seen.has(key)) return;
    seen.add(key);
    source.push(field);
  });

  source.forEach((field) => {
    const key = field?.key || field?.metric_key || field?.normalized_key;
    if (!key) return;
    data[key] = sampleValueForType(field?.type || field?.inferred_type);
  });

  return `curl -X POST ${apiBase}/api/v1/devices/${deviceId}/telemetry \\
  -H "Authorization: Bearer ${token}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "timestamp": "${new Date().toISOString()}",
    "type": "telemetry",
    "data": ${JSON.stringify(data, null, 2)}
  }'`;
}
